import { InAppMessagePresentResponse } from "../present/InAppMessagePresentResponse"
import { InAppMessageDeliverRequest } from "./InAppMessageDeliverRequest"

export type DeliverResponseCode =
  | "DELIVER"
  | "WORKSPACE_NOT_FOUND"
  | "IN_APP_MESSAGE_NOT_FOUND"
  | "IDENTIFIER_CHANGED"
  | "INELIGIBLE"
  | "EXCEPTION"

export class InAppMessageDeliverResponse {
  constructor(
    public readonly dispatchId: string,
    public readonly inAppMessageKey: number,
    public readonly code: DeliverResponseCode,
    public readonly presentResponse: InAppMessagePresentResponse | null
  ) {}

  /**
   * @override
   */
  toString() {
    return `InAppMessageDeliverResponse(dispatchId=${this.dispatchId}, inAppMessageKey=${this.inAppMessageKey}, code=${this.code})`
  }

  static of(
    request: InAppMessageDeliverRequest,
    code: DeliverResponseCode,
    presentResponse: InAppMessagePresentResponse | null = null
  ): InAppMessageDeliverResponse {
    return new InAppMessageDeliverResponse(request.dispatchId, request.inAppMessageKey, code, presentResponse)
  }
}
